import { createValidator, required, richTextMaxLength } from 'util/validation'

import { EscutaInicialState } from './model'
import { MotivoConsultaFormModel } from './motivo-consulta/MotivoConsultaForm'

export const escutaInicialValidator = () =>
  createValidator<EscutaInicialState>({
    motivoConsulta: motivoConsultaValidator,
  })

const motivoConsultaValidator = createValidator<MotivoConsultaFormModel>({
  ciap: [required],
  texto: [richTextMaxLength(4000)],
})
